"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadTranslations = uploadTranslations;
const cms_client_1 = require("@finbackoffice/cms-client");
const enums_1 = require("@finbackoffice/enums");
const fs_1 = __importDefault(require("fs"));
const path_1 = __importDefault(require("path"));
function extendTranslationRecordWithScopes(userInterfaces, scope, deviceType) {
    return userInterfaces.map((record) => ({
        ...record,
        scopes: [scope, deviceType],
    }));
}
async function uploadTranslations(baseUrl, deviceType) {
    const directoryPath = path_1.default.join(process.cwd(), "translations");
    const files = fs_1.default.readdirSync(directoryPath);
    const translations = [];
    for (const file of files) {
        const scope = file.replace(".json", "");
        if (Object.values(enums_1.TranslationScopes).indexOf(scope) === -1) {
            throw new Error(`Unknown scope: ${scope} in ${file} . Please check TranslationScopes enum.`);
        }
        const json = fs_1.default.readFileSync(path_1.default.join(directoryPath, file), "utf8");
        const content = JSON.parse(json);
        const extendedContent = extendTranslationRecordWithScopes(content, scope, deviceType);
        translations.push(...extendedContent);
    }
    const cmsClient = new cms_client_1.CmsClient(baseUrl, `site-${deviceType}`);
    await cmsClient.importUserInterfaces({
        body: new Blob([JSON.stringify(translations, null, 0)], {
            type: "application/json",
        }),
        device_type: deviceType,
    });
}
//# sourceMappingURL=upload.js.map